<template>
  <div>
    <div v-for="field in form" :key="field.fieldName">
      <sk-select-wap
        v-if="field.displayType == 4"
        v-show="field.isShow"
        :check-flag="field.checkFlag"
        :field="field"
        :field-style="extraItem.extras('formfield.model') || 'style1-wap'"
        :field-value.sync="field.value"
        :field-result.sync="field.result"
        @change="valueChange"
      />
      <sk-radio-wap
        v-if="field.displayType == 3"
        v-show="field.isShow"
        :check-flag="field.checkFlag"
        :field="field"
        :field-style="extraItem.extras('formfield.model') || 'style1-wap'"
        :field-value.sync="field.value"
        :field-result.sync="field.result"
        @change="valueChange"
      />
      <sk-checkbox-select-wap
        v-if="field.displayType == 6"
        v-show="field.isShow"
        :check-flag="field.checkFlag"
        :field="field"
        :field-style="extraItem.extras('formfield.model') || 'style1-wap'"
        :field-value.sync="field.value"
        :field-result.sync="field.result"
        @change="valueChange"
      />
      <sk-checkbox-wap
        v-if="field.displayType == 5"
        v-show="field.isShow"
        :check-flag="field.checkFlag"
        :field="field"
        :field-style="extraItem.extras('formfield.model') || 'style1-wap'"
        :field-value.sync="field.value"
        :field-result.sync="field.result"
        @change="valueChange"
      />
      <sk-img-wap
        v-if="field.displayType == 7"
        v-show="field.isShow"
        :check-flag="field.checkFlag"
        :field="field"
        :field-value.sync="field.value"
        @change="valueChange"
      />
      <sk-file-wap
        v-if="field.displayType == 8"
        v-show="field.isShow"
        :check-flag="field.checkFlag"
        :field="field"
        :field-value.sync="field.value"
        @change="valueChange"
      />
      <sk-input-wap
        v-if="field.displayType == 1"
        v-show="field.isShow"
        :check-flag="field.checkFlag"
        :field="field"
        :field-style="extraItem.extras('formfield.model') || 'style1-wap'"
        :sms-type="'questionary'"
        :field-value.sync="field.value"
        @change="valueChange"
      />
      <sk-textarea-wap
        v-if="field.displayType == 2"
        v-show="field.isShow"
        :check-flag="field.checkFlag"
        :field="field"
        :field-style="extraItem.extras('formfield.model') || 'style1-wap'"
        :field-value.sync="field.value"
        @change="valueChange"
      />
      <sk-date-picker-wap
        v-if="field.fieldType == 'DATETIME'"
        v-show="field.isShow"
        :field="field"
        :check-flag="field.checkFlag"
        :field-value.sync="field.value"
        @change="valueChange"
      />
      <sk-line-wap v-if="field.fieldType === 'LINE'" />
      <sk-desc-wap v-if="field.fieldType === 'DESC'" :field="field" />
      <sk-radio-img-wap
        v-if="field.type == 9"
        v-show="field.isShow"
        :check-flag="field.checkFlag"
        :field="field"
        :field-style="extraItem.extras('formfield.model') || 'style1-wap'"
        :field-value.sync="field.value"
        :field-result.sync="field.result"
        @change="valueChange"
      />
      <sk-checkbox-img-wap
        v-if="field.type == 10"
        v-show="field.isShow"
        :check-flag="field.checkFlag"
        :field="field"
        :field-style="extraItem.extras('formfield.model') || 'style1-wap'"
        :field-value.sync="field.value"
        :field-result.sync="field.result"
        @change="valueChange"
      />
      <sk-policy-wap
        v-if="field.fieldType == 'POLICY'"
        v-show="field.isShow"
        :check-flag="field.checkFlag"
        :field="field"
        :field-value.sync="field.value"
        :field-result.sync="field.result"
        @change="valueChange"
      />
    </div>
  </div>
</template>

<script>
import rulesMixin from "../mixins/option-rules";
export default {
  name: "WapFields",
  mixins: [rulesMixin],
  props: {
    form: Array,
    extras: Object,
  },
  data() {
    return {
      userSelectValues: {},
    };
  },
};
</script>

<style scoped></style>
